import { Stack } from '@chakra-ui/react';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/uikit';
import { cancelPaymentAtom } from 'data/payments/atoms';
import { isFormLoading } from 'utils/atoms/dataFetchingAtom';

interface PaymentClientControlsDefaultProps {
  id: string;
  failureRedirectLink: string | null;
  onPaid: () => void;
  onCancel: () => Promise<void>;
  style?: 'default' | 'riobet';
}

export function PaymentClientControlsDefault({
  id,
  failureRedirectLink,
  onPaid,
  onCancel,
}: PaymentClientControlsDefaultProps) {
  const { t } = useTranslation('payments');
  const [cancelFormState, cancel] = useAtom(cancelPaymentAtom);
  const cancelIsLoading = isFormLoading(cancelFormState);

  return (
    <Stack
      spacing={['12px', '24px']}
      direction='row'
      w='100%'
      maxW='100%'
      justify='space-between'
      overflowX='hidden'
    >
      {failureRedirectLink ? (
        <Button
          isLoading={cancelIsLoading}
          w='50%'
          variant='grey'
          onClick={async () => {
            await onCancel();
            await cancel({ depositId: id });

            window.location.href = failureRedirectLink;
          }}
        >
          {t('cancel_payment')}
        </Button>
      ) : null}
      <Button
        w='50%'
        variant='payment'
        onClick={async () => {
          onPaid();
        }}
      >
        {t('payment_paid')}
      </Button>
    </Stack>
  );
}
